<template>
  <section>
    <div class="terms">
      <div class="heading">
        <h3>Disclosure</h3>
      </div>
      <div class="container wrapper">
        <p>Patrick McKay was compensated 1,000 USD for the dissemination of information about SNBH for the month of October 2025</p>
        <p>Patrick McKay was compensated 3,000 USD for the dissemination of information about LKYRF for the month of October 2025</p>
        <p>Patrick McKay was compensated 2,500 USD on November 4th, 2025 for 2 weeks of awareness about GPOX</p>
        <p>Patrick McKay was compensated 2,500 USD for the dissemination of information about KITL for the month of November 2025</p>
        <p>Patrick McKay was compensated 1,000 USD for the dissemination of information about PREM on November 17th - 28th 2025</p>
        <p>Patrick McKay was compensated 5,000 USD for social media awareness about CBLO starting December 10th, 2025</p>
        <p>Patrick McKay was compensated 2,000 USD for the dissemination of information about DWAY for the month of January 2026</p>
        <p>Patrick McKay was compensated 1,000 USD on February 18th, 2026 for 2 weeks of awareness about YUKI</p>
        <p>Patrick McKay was compensated 2,500 USD for the dissemination of information about DWAY for the month of February 2026</p>
        <p>Patrick McKay was compensated 500 USD on March 12th - 13th, 2026 for 2 weeks of awareness about ZENA</p>
        <p>Patrick McKay was compensated 1,000 USD on March 23rd, 2026 for 1 month of awareness about MAGE</p>
        <p>Patrick McKay was compensated 1,000 USD in March 2026 for 1 month of awareness about ECGI</p>
        <p>Patrick McKay was compensated 1,000 USD to cover FDCT from April 2nd - 9th, 2026</p>
        <p>Patrick McKay was compensated 1,500 USD to assist with awareness about BMXI from April 10th, 2026 - May 10th 2026</p>
        <p>Patrick McKay was compensated 1,000 USD to disseminate information about BRQL from May 11th, 2026 - May 15th 2026</p>
        <p>Patrick McKay was compensated 1,700 USD to disseminate information about IVHI for the month of May 2026</p>
        <p>Patrick McKay was compensated 1,000 USD to disseminate information about BLIS for 2 weeks starting May 28, 2026</p>
        <p>Patrick McKay was compensated 1,600 USD to disseminate information about PHSE for 2 weeks starting May 29, 2026</p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Disclosure"
};
</script>

<style lang="less" scoped>
.terms {
  margin: 45px 0 0 0;
  .heading {
    h3 {
      margin: 0 0 15px 0;
      font-size: 24px;
      font-size: 30px;
    }
    p {
      margin: 0 0 0 0;
    }
  }
  .container {
    border-top: 1px solid #EDEDED;
    text-align: left;
    a {
		font-weight: 700;
		color: #104475;
    }
    h3 {
      font-size: 22px;
    }
    p , ul , ol{
      line-height: 30px;
    }
  }
  .wrapper {
    width: 800px;
    margin: 35px auto 0 auto;
    padding: 25px 0 57px;
    @media(max-width: 1092px) {
        width: 768px;
    }
    @media(max-width: 868px) {
        width: 576px;
    }
    @media(max-width: 676px) {
      width: auto;
      padding-right: 20px !important;
      padding-left: 20px !important;
    }
  }
}
</style>
